import "./statistic.scss";

export default function Statistic() {
    return (
        <div>Statistic</div>
    )
}
